// extracted by mini-css-extract-plugin
export default {"helpIcon":"Label_helpIcon__9op88","label":"Label_label__WPSqz","tooltip":"Label_tooltip__BUtaY","help":"Label_help__ArWXC"};